import { Linkedin } from "lucide-react";

const PORTRAIT_URL =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_ia-concesiones-chile/artifacts/t574qnoq_image.png";

const LINKEDIN_URL = "https://www.linkedin.com/in/cecilia-mu%C3%B1oz-ramos-96904159/";

export default function CredibilitySection() {
  return (
    <section
      id="credibilidad"
      data-testid="credibility-section"
      className="py-0 relative scroll-mt-20"
    >
      <div className="max-w-5xl mx-auto px-4 lg:px-8 w-full">
        {/* Overline */}
        <p className="text-sm sm:text-base uppercase tracking-[0.2em] font-bold text-cyan-400 mb-4 text-center">
          Credibilidad
        </p>

        <div className="flex flex-col lg:flex-row items-center lg:items-start gap-8 lg:gap-12">
          {/* Photo */}
          <div className="flex-shrink-0">
            <img
              src={PORTRAIT_URL}
              alt="Cecilia Muñoz Ramos, fundadora de SoytuIA"
              data-testid="credibility-portrait"
              className="w-52 h-64 sm:w-56 sm:h-72 object-cover object-top rounded-2xl border-2 border-cyan-500/30 shadow-[0_0_40px_rgba(0,188,212,0.15)]"
            />
          </div>

          {/* Text */}
          <div className="text-center lg:text-left flex-1">
            <h2
              data-testid="credibility-title"
              className="text-2xl sm:text-3xl lg:text-4xl font-medium tracking-tight text-white mb-2"
              style={{ fontFamily: "Fraunces, serif" }}
            >
              Construido por alguien que estuvo donde tú estás hoy
            </h2>

            {/* Paragraphs */}
            <div className="space-y-3 mb-5">
              <p className="text-base sm:text-lg text-gray-200 leading-relaxed">
                Soy ingeniera y viví por años la presión de un trabajo donde
                cada decisión tenía consecuencias: plazos, documentos, análisis
                y responsabilidades sin margen de error.
              </p>
              <p className="text-base sm:text-lg text-gray-200 leading-relaxed">
                Hoy manejo mi tiempo y dejé de sentir esa sensación de
                "NO PUEDO MÁS" o "ESTOY AGOTADA".
              </p>
              <p className="text-base sm:text-lg leading-relaxed text-white">
                Construí estos agentes para resolver mis propios problemas, y
                funcionaron.
                <br />
                <span style={{ color: "#FF8FB8" }}>Ahora los preparo para ti y en el ámbito que necesites.</span>
              </p>
            </div>

            {/* LinkedIn button */}
            <a
              href={LINKEDIN_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="linkedin-button"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-white/15 text-white text-sm hover:border-cyan-400/50 hover:text-cyan-400 transition-all duration-200"
              style={{ fontFamily: "Outfit, sans-serif" }}
            >
              <Linkedin size={16} />
              Ver mi perfil en LinkedIn
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
